// src/utils/EventBus.js
/**
 * Simple event bus to handle cross-component communication
 * This allows components to communicate without direct props or complex state management
 */

const EventBus = {
  listeners: {},

  subscribe(event, callback) {
    if (!this.listeners[event]) {
      this.listeners[event] = [];
    }
    this.listeners[event].push(callback);
    
    // Return unsubscribe function for cleanup
    return () => this.unsubscribe(event, callback);
  },

  unsubscribe(event, callback) {
    if (this.listeners[event]) {
      this.listeners[event] = this.listeners[event].filter(cb => cb !== callback);
    }
  },

  emit(event, data) {
    if (this.listeners[event]) {
      this.listeners[event].forEach(callback => callback(data));
    }
  }
};

export default EventBus;